interface RankingProps {
  /** Localized heading for the ranking block (e.g. FIFA ranking). */
  label: string;
  /** Ranking position (e.g. 1, 12). */
  value: number;
}

export default function Ranking({ label, value }: RankingProps) {
  return (
    <div className="flex flex-col gap-[4px] items-center font-robotoRegular font-normal">
      <span className="text-[12px] leading-[16px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark">
        {label}
      </span>
      <div className="flex items-center">
        <span className="font-unibet font-medium text-[15px] leading-[9px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark">
          #
        </span>
        <span className="font-unibet font-medium text-[24px] leading-[24px] text-pmw-label-primary-light dark:text-pmw-label-primary-dark">
          {value}
        </span>
      </div>
    </div>
  );
}
